import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { trustPoints } from '../../data/landing';
import { rise, stagger } from '../../utils/motion';
const icons = [ShieldCheckIcon, BadgeCheckIcon, StarIcon];
export function TrustRow() {
  return <section aria-labelledby="trust-title" className="mx-auto max-w-6xl px-5 py-20 lg:py-28" data-id="element-429" data-mp="29rl8ngrjy5xu">
      <h2 id="trust-title" className="max-w-[20ch] text-[32px] font-bold leading-[1.08] tracking-[-0.015em] lg:text-[44px]" data-id="element-430" data-mp="2nizwq20bgxbr">
        Built so both sides can trust the booking.
      </h2>
      <motion.ul variants={stagger} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-15% 0px'
    }} className="mt-12 grid gap-10 md:grid-cols-3 md:gap-0" data-id="element-431" data-mp="2xigyi8cg6r2g">
        {trustPoints.map((t, i) => {
        const Icon = icons[i];
        return <motion.li key={t.title} variants={rise} className="md:border-l md:border-line md:px-8 md:first:border-l-0 md:first:pl-0" data-id="element-432" data-mp="y64rdh6941m9" data-mpi={i}>
              <Icon className="h-7 w-7 text-brand-strong" data-id="element-433" data-mp="2ilf8u7nl0ol8" />
              <p className="mt-4 text-lg font-bold" data-id="element-434" data-mp="2nno1t40gfqnc">{t.title}</p>
              <p className="mt-2 max-w-[36ch] text-[16px] leading-relaxed text-ink-2" data-id="element-435" data-mp="2rogde3wsu7ms">{t.body}</p>
            </motion.li>;
      })}
      </motion.ul>
    </section>;
}